import React from "react";
import "./ArticleTag.css";

export default function ArticleTag({ text }) {
  return (
    <div className="at-container">
      <span className="at-text">{text}</span>
    </div>
  );
}
